export const getUser = () => {
  return localStorage.getItem("token");
};
